// Picks the codec analyzer for a parsed file. Each analyzer returns null when
// it does not apply (e.g. the AAC analyzer for an ALAC track).
import type { ParsedFile } from '../parsers/types';
import type { CodecAnalysis } from './types';
import { analyze as mp3 } from './mp3';
import { analyze as aac } from './aac';
import { analyze as flac } from './flac';
import { analyze as ogg } from './ogg';

const analyzers = [mp3, aac, flac, ogg];

export function codecFor(pf: ParsedFile, bytes: Uint8Array): CodecAnalysis | null {
  for (const a of analyzers) {
    try {
      const r = a(pf, bytes);
      if (r) return r;
    } catch (e) {
      console.warn('codec analyzer failed', e);
    }
  }
  return null;
}
